export default "__VITE_ASSET__CoBqZPne__"